import { useNavigate } from "react-router-dom";
import { useUser } from "../../../contexts/UserContext";
import { PiSignOut } from "react-icons/pi";
import { CiShop, CiSettings } from "react-icons/ci";
import { FaUserEdit, FaTshirt } from "react-icons/fa";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { TbClipboardList } from "react-icons/tb";
import { MdChecklist } from "react-icons/md";

import "./UserMenu.css";

export default function UserMenu() {
    const navigate = useNavigate();
    const { user, logout } = useUser();

    const handleLogout = () => {
        // the fetch below should log the user out on the server
        fetch(`${import.meta.env.VITE_SERVER_URL || ""}/api/auth/logout`, {
            credentials: "include",
        })
            .then((res) => {
                return res.json();
            })
            .then((json) => {
                // json.user should be undefined here.
                logout();
            })
            .catch((err) => console.error("Failed to log out:", err));
    };

    return (
        <div className="user-menu">
            <div className="user-menu-info">
                <img
                    className="title-icon"
                    style={{ borderRadius: "100%" }}
                    src={user?.profileImage}
                />
                <div>
                    <div className="user-menu-info-name">
                        {user?.displayName}
                    </div>
                    <div className="user-menu-info-id">{user?.id}</div>
                </div>
            </div>
            <button
                className="user-menu-button"
                onClick={() => navigate("/avatar")}
            >
                <FaUserEdit /> <span>Avatar</span>
            </button>
            <button
                className="user-menu-button"
                onClick={() => navigate("/commands")}
            >
                <AiOutlineExclamationCircle /> <span>Commands</span>
            </button>
            <button
                className="user-menu-button"
                onClick={() => navigate(`/artcollection?userId=${user?.id}`)}
            >
                <AiOutlineExclamationCircle /> <span>Art Collection</span>
            </button>
            <button
                className="user-menu-button"
                onClick={() => navigate(`/hunterfashion/collection`)}
            >
                <FaTshirt /> <span>Hunter Fashion</span>
            </button>
            <button
                className="user-menu-button"
                onClick={() => navigate("/rules")}
            >
                <TbClipboardList /> <span>Rules</span>
            </button>
            {import.meta.env.DEV && (
                <button
                    className="user-menu-button"
                    onClick={() => navigate("/shop")}
                >
                    <CiShop /> <span>Shop</span>
                </button>
            )}

            {user?.isModerator && (
                <>
                    <div className="separator" />
                    <button
                        className="user-menu-button"
                        style={{
                            borderBottomLeftRadius:
                                "var(--theme-border-radius)",
                            borderBottomRightRadius:
                                "var(--theme-border-radius)",
                        }}
                        onClick={() => {
                            navigate("/admin/activityfeed");
                        }}
                    >
                        <MdChecklist /> <span>Activity Feed</span>
                    </button>
                    <button
                        className="user-menu-button"
                        style={{
                            borderBottomLeftRadius:
                                "var(--theme-border-radius)",
                            borderBottomRightRadius:
                                "var(--theme-border-radius)",
                        }}
                        onClick={() => {
                            navigate("/admin/config");
                        }}
                    >
                        <CiSettings /> <span>Admin Config</span>
                    </button>
                    <button
                        className="user-menu-button"
                        style={{
                            borderBottomLeftRadius:
                                "var(--theme-border-radius)",
                            borderBottomRightRadius:
                                "var(--theme-border-radius)",
                        }}
                        onClick={() => {
                            navigate("/admin/tracker");
                        }}
                    >
                        <CiSettings /> <span>Redeem Stats</span>
                    </button>
                </>
            )}
            <div className="separator" />
            <button
                className="user-menu-button"
                style={{
                    borderBottomLeftRadius: "var(--theme-border-radius)",
                    borderBottomRightRadius: "var(--theme-border-radius)",
                }}
                onClick={() => {
                    handleLogout();
                }}
            >
                <PiSignOut /> <span>Logout</span>
            </button>
        </div>
    );
}
